import SidebarCollection from './SidebarCollection'
export default SidebarCollection
